import React, { useContext, useEffect, useRef, ReactNode, Fragment } from "react";
import { TextField, InputAdornment } from "@mui/material";

import { EditableGroupContext } from "../../EditableGroup/EditableGroup";

export enum CharacterCasing {
    normal = 0,
    upper = 1,
    lower = 2,
}

const TextInputField: React.FunctionComponent<{
    label: string,
    value?: string;
    password?: boolean;
    required?: boolean;
    readOnly?: boolean;
    autoFocus?: boolean;
    focused?: boolean;
    clearOnFocus?: boolean;
    casing?: CharacterCasing;
    multiLine?: boolean;
    maxLength?: number | null;
    maxWidth?: number | string;
    height?: number | string;
    showCharacterCount?: boolean | null;
    onChange?: (value: string) => void;
    onBlur?: () => void;
    onSubmit?: (value: string) => void;
    testId?: string;
    iconButton?: ReactNode;
    onEnterKeyPress?: (value: string) => void;
    placeholder?: string;
}> = (props) => {
    const groupContext = useContext(EditableGroupContext);
    const ref = useRef<HTMLInputElement>();


    useEffect(() => {
        if (ref.current) {
            ref.current.value = props.value || "";
        }
    }, [groupContext.buildId]);


    let val = props.value || "";
    if (props.maxLength != null) {
        if (val.length > props.maxLength) {
            val = val.substring(0, props.maxLength);
        }
    }

    const formatValue = (val: string) => {
        if (props.casing == CharacterCasing.upper) {
            val = val.toUpperCase();
        }
        else if (props.casing == CharacterCasing.lower) {
            val = val.toLowerCase();
        }
        if (props.maxLength != null && val.length >= props.maxLength) {
            val = val.substring(0, props.maxLength);
        }
        return val;
    }

    val = formatValue(val);

    return (
        <Fragment>
            <TextField
                data-testid={props.testId ? `${props.testId}-container` : undefined}
                autoFocus={props.autoFocus}
                focused={props.focused}
                InputProps={{
                    endAdornment: props.iconButton && (
                        <InputAdornment position="end">
                            {props.iconButton}
                        </InputAdornment>
                    )
                }}
                inputProps={{
                    'aria-labelledby': props.label,
                    autoComplete: 'off',
                    name: "input",
                    'data-testid': props.testId,
                    style: {
                        minHeight: props.multiLine == true ? (props.height == null ? 80 : props.height) : "auto"
                    }
                }}
                onFocus={() => {
                    if (props.clearOnFocus == true) {
                        if (props.onChange != null) {
                            props.onChange("");
                        }
                    }
                }}
                multiline={props.multiLine == true}
                style={{
                    maxWidth: props.maxWidth == null ? 225 : props.maxWidth,
                    width: "100%",
                }}
                disabled={props.readOnly == true}
                required={props.required == true}
                inputRef={ref}
                placeholder={props.placeholder}
                type={props.password == true ? "password" : "text"}
                size="small"
                label={props.label}
                variant="outlined"
                value={val}
                onChange={(e) => {
                    const val = formatValue(e.target.value);
                    if (props.onChange != null) {
                        props.onChange(val);
                    }
                }}
                onBlur={props.onBlur}
                onKeyDown={(e) => {
                    if (e.key == "Enter") {
                        if (ref.current) {
                            if (props.onSubmit) {
                                props.onSubmit(val);
                            }
                            if (props.onEnterKeyPress) {
                                props.onEnterKeyPress(val);
                            }
                        }
                    }

                }}
            />
            {(props.maxLength != null && props.showCharacterCount != null) && (
                <div style={{ fontSize: "0.75rem", textAlign: "right", marginTop: "0.5rem" }}>
                    {props.maxLength - val.length}/{props.maxLength}
                </div>
            )}
        </Fragment>
    );
}

export default TextInputField;
